import React from 'react';
import Heading from 'ui/typography/Heading/Heading';
import Button from 'ui/controls/Button/Button';
import {CustomScroll as Scroll} from 'ui/controls/CustomScroll/CustomScroll';
import ErrorBoundary from 'modules/boundary/components/ErrorBoundary';
import {SettingList} from './SettingList';
import './PopupCookie.styl';

export const PageCookie = (props) => {
	const {
		children,
		list,
	} = props;
	return (
		<>
			<div className="page-cookie-heading">
				<Heading level="title-small" modificator="margin">
					Cookie Settings
				</Heading>
			</div>
			<Scroll className="page-cookie-list-wrapper">
				<ErrorBoundary>
					<SettingList cookieList={list} />
					{children}
				</ErrorBoundary>
			</Scroll>
		</>
	);
};
